import type { FC } from 'react'
import { ListItem, ListItemAvatar, ListItemText, Skeleton} from '../primitives/index.js'

export interface ListItemSkeletonProps {}

export const ListItemSkeleton: FC<ListItemSkeletonProps> = () => (
  <ListItem style={{ padding: 0 }}>
    <ListItemAvatar>
      <Skeleton style={{ marginLeft: 4 }} variant="circular" width={40} height={40} />
    </ListItemAvatar>
    <ListItemText>
      <Skeleton animation="wave" width="100%" height={60} variant="rectangular" />
    </ListItemText>
  </ListItem>
)

export default ListItemSkeleton
